import React, { useEffect } from "react";
import "./projecttabs.css";
import { AvatarGroup } from "@material-ui/lab";
// import { Avatar } from "@material-ui/core";
import { useHistory } from 'react-router-dom';
import { Button, CircularProgress } from '@material-ui/core';
import { renameFolder } from '../../../../../actions/projectActions';
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useDispatch, useSelector } from 'react-redux';

function ProjectTabs({ name, projectId }) {
  var Today = new Date();
  const dispatch = useDispatch();
  const history = useHistory();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const [newName, setNewName] = React.useState(name);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickOpen = () => {
    setOpen(true);
    handleClose();
  };

  const handleDialogClose = () => {
    setOpen(false);
    handleClose();
  };

  const handleRedirect = () => {
    if (projectId) {
      history.push(`/home/project/files/${projectId}`)
    }
  }

  const handleRename = () => {
    if (newName) {
      dispatch(renameFolder({
        folderId: projectId,
        name: newName
      }))
    } else {
      setOpen(false);
    }
  }

  const folderRename = useSelector(state => state.folderRename);
  const { loading: loadingRename, renameFolderInfo } = folderRename;

  useEffect(() => {
    if (renameFolderInfo) {
      handleDialogClose();
    }
  }, [renameFolderInfo])

  return (
    <div className="projecttabs">
      <div className="folder__top"></div>
      <div className="recentfiletab__header">
        {" "}
        <h3 onClick={handleRedirect}>{name}</h3>
        <MoreHorizIcon className="recentfiletab__option" aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>...</MoreHorizIcon>
      </div>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {/* <MenuItem onClick={handleClose}>Edit</MenuItem> */}
        <MenuItem onClick={handleClickOpen}>Rename</MenuItem>
        <MenuItem onClick={handleClose}>Delete</MenuItem>
      </Menu>
      <AvatarGroup max={3}>
        {/* <Avatar />
        <Avatar />
        <Avatar />
        <Avatar /> */}
      </AvatarGroup>
      <p className="projecttabs__date">
        {Today.getDate() +
          "/" +
          (Today.getMonth() + 1) +
          "/" +
          Today.getFullYear()}
      </p>
      <Dialog open={open} onClose={handleDialogClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Rename Folder</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Enter the new name for the folder in the below text field
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            value={newName}
            onChange={e => setNewName(e.target.value)}
            id="name"
            label="New File Name"
            type="text"
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="primary">
            Cancel
          </Button>
          {loadingRename ? <CircularProgress /> : (
            <Button onClick={handleRename} color="primary">
              Rename
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default ProjectTabs;
